var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],key:_vm.key,attrs:{"value":_vm.value},on:{"input":_vm.input}},'v-textarea',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }